import type { DateTimeContextProps } from '@rtkwlf/fenrir-react';
import { useFormattedDate } from '@rtkwlf/fenrir-react';

import { useDateFormat } from './use-date-format/use-date-format';

export const useDateFormatter = (
  value: string | number | Date,
  format?: DateTimeContextProps['format'],
  overrideUtcFormat?: boolean,
) => {
  const dateFormat = useDateFormat(format, overrideUtcFormat);

  return useFormattedDate(new Date(value), dateFormat);
};
